import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getDatabase, ref, set } from 'firebase/database';
import { app } from '../firbase';
import '../styles/Confirmation.css'
const UpdatedConfirmation = () => {
//   const { state } = useLocation();
  const [message, setMessage] = useState('');
  const db = getDatabase(app);
  const location = useLocation();
  const navigate = useNavigate();
  const { updatedBooking, bookingId } = location.state || {};

  const handleHomePage = () => {
    navigate('/', { state: location.state });
  };

  useEffect(() => {
    const updateBooking = async () => {
      try {
        await set(ref(db, `bookings/${bookingId}`), updatedBooking);
        setMessage(`${updatedBooking.name} successfully updated the booking from ${updatedBooking.startTime} to ${updatedBooking.endTime} on ${updatedBooking.date}`);
      } catch (err) {
        setMessage('Failed to update booking: ' + err.message);
      }
    };
    if (updatedBooking && bookingId) updateBooking();
  }, [db, updatedBooking, bookingId]);


  return (
    <div className="confirmation-container">
      <h2>Booking Updated</h2>
      <p><strong>{message}</strong></p>
      <div className="confirmation-buttons confirmation-button-update">
      <button onClick={handleHomePage}>Go To Home</button>
      </div>
    </div>
  );
};

export default UpdatedConfirmation;
